export const PAGES_WITH_UID = [
	'login',
	'checkout',
	'promo-checkout',
	'first-login',
	'success-payment',
];
